import type { ImageRecord } from '../types';
export class ImagePanelService {
    // eslint-disable-next-line no-useless-constructor
    constructor(public scale = {
        step: 0.2,
        max: 4,
        min: 0.5,
    }) {}

    isShow = false;
    imageList: ImageRecord[] = [];
    currentImageIndex = 0;
    rateNum = 0;
    size = 1;
    position: { top: number, left: number } = { left: 0, top: 0 };
    startPosition: { top: number, left: number } = { left: 0, top: 0 };
    isMoving = false;

    open(index?: number) {
        this.isShow = true;
        index !== undefined && (this.currentImageIndex = index);
    }

    close() {
        this.isShow = false;
        this.rateNum = 0;
        this.resetPosition();
        this.resetScale();
    }

    toPrev() {
        if (this.currentImageIndex > 0) {
            this.currentImageIndex--;
            this.rateNum = 0;
            this.resetPosition();
            this.resetScale();
        }
    }

    toNext() {
        if (this.currentImageIndex + 1 < this.imageList.length) {
            this.currentImageIndex++;
            this.rateNum = 0;
            this.resetPosition();
            this.resetScale();
        }
    }

    rotatePicture() {
        this.rateNum++;
        this.resetPosition();
    }

    zoomIn() {
        if (this.size < this.scale.max) {
            this.size += this.scale.step;
            this.resetPosition();
        }
    }

    zoomOut() {
        if (this.size > this.scale.min) {
            this.size -= this.scale.step;
            this.resetPosition();
        }
    }

    selectImage(index: number) {
        this.currentImageIndex = index;
        this.rateNum = 0;
        this.resetPosition();
        this.resetScale();
    }

    startMove(event: MouseEvent) {
        this.isMoving = true;
        const { x, y } = event;
        const { top, left } = this.position;
        this.startPosition = {
            top: y - top,
            left: x - left,
        };
    }

    moveImage(event: MouseEvent) {
        if (this.isMoving) {
            const { x, y } = event;
            this.position = {
                top: y - this.startPosition.top,
                left: x - this.startPosition.left,
            };
        }
    }

    endMove() {
        this.isMoving = false;
        this.startPosition = {
            top: 0,
            left: 0,
        };
    }

    resetPosition() {
        this.position = { left: 0, top: 0 };
    }

    resetScale() {
        this.size = 1;
    }
}
